import { getDefaultCRUDMethods } from "./Repository";

const resource = "/Societe";

export default {
  get: getDefaultCRUDMethods({ resource }).get
};
